import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';

const AppContainer = styled.div`
  display: flex;
  height: 100vh;
  background: var(--background);
  color: var(--text-primary);
  position: relative;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
`;

const MainContentWrapper = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  border-radius: 20px 20px 0 0;
`;

const MainContent = styled.main`
  flex: 1;
  overflow-x: hidden;
  background: #ffffff;
  height: 100%;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255, 0.7);
  // backdrop-filter: blur(1px);
  z-index: 998;
  opacity: ${props => props.show ? 1 : 0};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: ${props => props.show ? 'auto' : 'none'};
`;

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };
  
  return (
    <AppContainer>
      <Sidebar collapsed={sidebarCollapsed} onClose={() => setSidebarCollapsed(true)} />
      <ContentWrapper>
        <Header toggleSidebar={toggleSidebar} isSidebarCollapsed={sidebarCollapsed} />
        <MainContentWrapper>
          <Backdrop show={!sidebarCollapsed} onClick={() => setSidebarCollapsed(true)} />
          <MainContent>{children}</MainContent>
        </MainContentWrapper>
      </ContentWrapper>
    </AppContainer>
  );
};

export default Layout;
